<e-dialog [open]="open()" (openChange)="onOpenChange($event)" [title]="text().title" size="md">
  <ng-template>
    <div class="trash-list">
      @if (error()) {
        <div class="trash-error">{{ error() }}</div>
      }
      @if (loading()) {
        <div class="trash-empty">{{ text().loading }}</div>
      } @else if (items().length === 0) {
        <div class="trash-empty">{{ text().empty }}</div>
      } @else {
        @for (item of items(); track item.id) {
          <div class="trash-row">
            <span class="trash-name" [title]="item.name">{{ item.name }}</span>
            <span class="trash-date">{{ formatDeletedOn(item.lastModifiedOn) }}</span>
            <button
              eBtn
              size="sm"
              color="highlight"
              icon="trash-arrow-up"
              iconColor="primary-75"
              [tooltip]="text().restore"
              [disabled]="purgingAll()"
              (click)="restore(item)"
            ></button>
            <button
              eBtn
              size="sm"
              color="highlight"
              icon="xmark"
              iconColor="danger"
              [tooltip]="text().purge"
              [disabled]="purgingAll()"
              (click)="purge(item)"
            ></button>
          </div>
        }
      }
      @if (!loading() && items().length > 1) {
        <div class="trash-actions">
          <button
            eBtn
            color="highlight"
            icon="trash-can"
            iconColor="danger"
            [disabled]="purgingAll()"
            (click)="purgeAll()"
          >{{ text().purgeAll }}</button>
        </div>
      }
    </div>
  </ng-template>
</e-dialog>
